// @ngInject
function CompaniesApiService(ResourcesService) {

    var endpoint = 'companies';

    return {
        getAll: ResourcesService.apiFactory.get(endpoint),
        listAll: ResourcesService.apiFactory.get(endpoint + '/brief'),
        getCompany: ResourcesService.apiFactory.get(endpoint),
        createCompany: ResourcesService.apiFactory.create(endpoint,'Company'),
        updateCompany: updateCompany,
        getCompanyTypes: ResourcesService.apiFactory.get(endpoint + '/companytypes'),
        getSuppliers: ResourcesService.apiFactory.get(endpoint + '/suppliers'),
        getSuppliersBrief: ResourcesService.apiFactory.get(endpoint + '/suppliersbrief'),
        getDeliveryTerms: ResourcesService.apiFactory.get(endpoint + '/deliveryterms'),
        getPaymentTerms: ResourcesService.apiFactory.get(endpoint + '/paymentterms'),
        getShippingMethods: ResourcesService.apiFactory.get(endpoint + '/shippingmethods'),
        getAddressTypes: ResourcesService.apiFactory.get(endpoint + '/addresstypes'),
        getContactInfoTypes: ResourcesService.apiFactory.get(endpoint + '/contactinfotypes'),
        getCurrencies: ResourcesService.apiFactory.get(endpoint + '/currencies'),
        getActiveUsers: ResourcesService.apiFactory.get(endpoint + '/activeusers'),
        getLanguages: ResourcesService.apiFactory.get(endpoint + '/languages'),
        getPricingModels: ResourcesService.apiFactory.get(endpoint + '/pricemodels'),
        getPriceListBriefs: ResourcesService.apiFactory.get(endpoint + '/pricelists')
    };

    function updateCompany(id, data) {

        // The internal json stringification of DSHttpAdapter seems to cause some object fields to go
        // missing for some reason.
        data = JSON.stringify(data);

        return ResourcesService.apiFactory.update(endpoint + '/' + id, 'Company')(data);
    }
}


angular.module('companies.api', [])
    .factory('CompaniesApiService', CompaniesApiService);
